import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { translate } from 'services/i18nService';

import TierItem from './TierItem';
import styles from './index.css';


const RecentSpendingTierLegend = (props) => {
  const {
    isOpen,
    onToggle,
  } = props;

  const items = useMemo(() => [
    {
      type: '0',
      text: `${translate('v2broadcast.less.than')} 20`,
    },
    {
      type: '1',
      text: '1 - 20+',
    },
    {
      type: '2',
      text: '2 - 100+',
    },
    {
      type: '3',
      text: '3 - 250+',
    },
    {
      type: '4',
      text: '4 - 500+',
    },
  ], []);

  const renderItem = useCallback(({ text, type }) => (
    <TierItem text={text} type={type} />
  ), []);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.recentSpendingTierLegend}>
      <div className={styles.header}>
        <span className={styles.headerTitle}>
          {translate('v2broadcast.user.legend.tooltip')}
        </span>
        <IconButton
          className={styles.headerCloseButton}
          onClick={onToggle}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div className={styles.title}>
        {translate('v2broadcast.tokens.spent.last.two.weeks')}
      </div>
      {items.map(renderItem)}
    </div>
  );
};

RecentSpendingTierLegend.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default memo(RecentSpendingTierLegend);
